<template>
  <div 
    :class="[
      'fixed top-5 w-80 z-[9999]',
      isRTL ? 'left-5' : 'right-5'
    ]"
  >
    <transition-group name="toast">
      <div
        v-for="toast in toastStore.toasts"
        :key="toast.id"
        :class="[
          'alert py-3 px-4 mb-3 rounded-md flex items-center justify-between shadow-md',
          {
            'text-success-500 bg-success-50 border border-success-200': toast.type === 'success',
            'text-danger-500 bg-danger-50 border border-danger-200': toast.type === 'error',
            'text-warning-500 bg-warning-50 border border-warning-200': toast.type === 'warning',
            'text-info-500 bg-info-50 border border-info-200': toast.type === 'info'
          }
        ]"
      >
        <div class="flex items-center">
          <i 
            :class="[
              'text-lg',
              isRTL ? 'ml-2' : 'mr-2',
              {
                'ri-checkbox-circle-line': toast.type === 'success',
                'ri-error-warning-line': toast.type === 'error',
                'ri-alert-line': toast.type === 'warning',
                'ri-information-line': toast.type === 'info'
              }
            ]"
          ></i>
          <span>{{ toast.message }}</span>
        </div>
        <button @click="toastStore.remove(toast.id)" class="leading-none text-[20px] close-btn">
          <i class="ri-close-line"></i>
        </button>
      </div>
    </transition-group>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import toastStore from '@/utils/toastService';

export default defineComponent({
  name: 'ToastNotifications',
  setup() {
    const { locale } = useI18n();
    
    // Check if current locale is RTL
    const isRTL = computed(() => ['he', 'ar'].includes(locale.value));
    
    return {
      toastStore,
      isRTL
    };
  }
});
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

/* LTR animations */
[dir="ltr"] .toast-enter-from,
[dir="ltr"] .toast-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

/* RTL animations */
[dir="rtl"] .toast-enter-from,
[dir="rtl"] .toast-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

/* Fallback for when dir is not set */
.toast-enter-from:not([dir]) {
  opacity: 0;
  transform: translateX(30px);
}
.toast-leave-to:not([dir]) {
  opacity: 0;
  transform: translateX(30px);
}
</style> 
